module.exports = __webpack_public_path__ + "img/4.4090e98a.jpg";